import './App.css';
import Navbar from './header/navbar';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import Home from './pages';
import Login from './pages/login';
import NotFound from './pages/notFound';
import GmailCallback from './pages/gmail-callback';
import GmailTest from './pages/gmail-test';
import ManualApplication from './pages/manual-application';
import Dashboard from './pages/dashboard';
import About from './pages/about';
import Profile from './pages/profile';
import Settings from './pages/settings';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <div className="container">
        <Router>
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/login" element={<Login />} />
              <Route path="/about" element={<About />} />
              <Route path="/gmail-callback" element={<GmailCallback />} />
              <Route path="/gmail-test" element={<GmailTest />} />
              <Route path="/add-application" element={<ManualApplication />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profile/settings" element={<Settings />} />
            </Routes>
          </main>
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;
